var _path;
import * as React from "react";
function SvgExclamationFill(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 20c0 8.838-7.164 16-16 16S4 28.838 4 20c0-8.833 7.164-16 16-16s16 7.167 16 16zm-16 3.226a2.968 2.968 0 100 5.935 2.968 2.968 0 000-5.935zm-2.818-10.668l.479 8.774a.774.774 0 00.773.732h3.132c.411 0 .75-.32.773-.732l.479-8.774a.774.774 0 00-.773-.816h-4.09a.774.774 0 00-.773.816z"
  })));
}
export default SvgExclamationFill;